import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaymentPortalContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PaymentPortalContainer" */
                '@perpay-web/fintech/components/containers/PaymentPortalContainer'
            ),
    );
